import React from "react";
import {
    Button,
    checkAndSetError,
    clearInputFormErrorFields,
    convertInputFormToObject,
    DateTimePickerField,
    inputFormIsValid,
    SelectField
} from "../../Components/Inputs";
import {GridCell, gridConstants, GridContainer} from "../../Components/Grid";
import {LinkButton} from "../../Components/Link";
import {locations} from "../../Utilities/Location";
import {isStartBeforeEnd} from "../../Utilities/Types/dateUtilities";
import {error as notifyError} from "../../Components/Notifications/NotifyUser/notifyUserUtility";

import type {ListItem} from "../../Utilities/Types/listUtilities";

interface LibraryQueueFormProps {
    handleAssignQueueItems: (data: Record<string, unknown>) => void;
    loanForm: Record<string, any>;
    shippingLocations: ListItem[];
    students: ListItem[];
}

export const LibraryQueueForm = ({
                                     handleAssignQueueItems,
                                     loanForm,
                                     shippingLocations,
                                     students
                                 }: LibraryQueueFormProps) => {

    const handleClickSubmit = () => {
        const loanModel = convertInputFormToObject(loanForm);

        clearInputFormErrorFields(loanForm);

        checkAndSetError([
            loanForm.needFrom,
            loanForm.needTo,
            loanForm.shippingLocationId,
            loanForm.studentId,
        ]);

        const hasDateRange = loanModel.needFrom && loanModel.needTo;
        const isInvalidDateRange = hasDateRange && !isStartBeforeEnd(String(loanModel.needFrom), String(loanModel.needTo));

        if (isInvalidDateRange) {
            const validationMessage = "Need From date must be before Need To date.";
            loanForm.needFrom.setError("Need From date must be before Need To date.");
            loanForm.needTo.setError("Need To date must be after Need From date.");
            notifyError(validationMessage);
        }

        if (!inputFormIsValid(loanForm)) {
            return;
        }

        handleAssignQueueItems(loanModel);
    }

    return <>
        <GridContainer hasMarginX>

            <DateTimePickerField
                {...loanForm.needFrom}
                medium_columns={gridConstants.column.SIX}
                large_columns={gridConstants.column.THREE}
            />

            <DateTimePickerField
                {...loanForm.needTo}
                medium_columns={gridConstants.column.SIX}
                large_columns={gridConstants.column.THREE}
            />

            <SelectField
                {...loanForm.shippingLocationId}
                defaultOption={`Select Shipping Location`}
                medium_columns={gridConstants.column.SIX}
                large_columns={gridConstants.column.THREE}
                label={`Location`}
                options={shippingLocations}
            />

            <SelectField
                {...loanForm.studentId}
                defaultOption={`Select Student`}
                medium_columns={gridConstants.column.SIX}
                large_columns={gridConstants.column.THREE}
                label={`Student`}
                options={students}
            />
            <GridCell large_offset={gridConstants.column.THREE} medium_columns={gridConstants.column.SIX} large_columns={gridConstants.column.THREE}>
                <LinkButton {...locations.SHIPPING_LOCATION_ADD.link} isExpanded />
            </GridCell>
            <GridCell medium_columns={gridConstants.column.SIX} large_columns={gridConstants.column.THREE}>
                <Button
                    isPrimary
                    label={`Submit`}
                    name={`btnSubmit`}
                    onClick={handleClickSubmit}
                />
            </GridCell>
        </GridContainer>
        <br/>
        <br/>
    </>;
};

